<template>
  <div>
    <v-base-card v-if="!reissued">
      <template v-slot:heading>
        パスワード再発行
      </template>
      <template v-slot:content>
        <v-form>
          <table class="ml-3 mt-2">
            <thead>
              <tr>
                <th class="search-th">ログインID</th>
                <th class="search-th">メールアドレス</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <v-text-field
                    class="text-field ma-0"
                    v-model="loginId"
                    :rules="rules.loginIdRules"
                    outlined
                    dense
                    required
                    hide-details
                    color="secondary"
                  ></v-text-field>
                </td>
                <td>
                  <v-text-field
                    class="text-field ma-0"
                    v-model="mail"
                    :rules="rules.mail"
                    outlined
                    dense
                    required
                    hide-details
                    color="secondary"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td>
                </td>
                <td class="f-15">
                  ※教室のメールアドレスを入力してください
                </td>
              </tr>
            </tbody>
          </table>
          <v-btn
            color="secondary"
            class="ml-3 mt-3 mb-8"
            small
            :disabled="disabled"
            @click.stop="resetPassword"
          >
            再発行
          </v-btn>
      </v-form>
      </template>
    </v-base-card>
    <v-container class="fill-height" v-else>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="8" align="center" justify="center">
          <v-row justify="center" class="mt-8 mb-10">
            <p class="mb-0">パスワードの再発行が完了しました。</p>
            <p class="mb-0">後ほどパスワード再発行完了メール（自動送信）をお送りいたします。</p>
            <p class="mb-0">数日経ってもメールが届かない場合、お問い合わせをお願いいたします。</p>
          </v-row>
          <a color="secondary" @click="$router.push('/sign_in')">
            TOPへ
          </a>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import rules from '../rules'

export default {
  components: {
    VBaseCard,
  },
  data() {
    return {
      loginId: '',
      mail: '',
      rules: rules,
      reissued: false,
    }
  },
  computed: {
    disabled() {
      return (!this.loginId || !this.mail || !this.rules.mail)
    }
  },
  methods: {
    async resetPassword() {
      // パスワードをランダムに生成
      // 【パスワード条件：半角英数字、半角記号!#$%&?@が使用可能、8～30文字】
      const str = "abcdefghjkmpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789!#$%&?@";
      let password = Array.from(Array(str.length)).map((v, index) => str[index])
      password = this.shuffle(password).join('').slice(0, 7)

      //パスワード再設定メール送信
      const res = await this.$axios.post('/api/v1/lost_password/update', {
        mail: this.mail,
        login: this.loginId,
        password: password,
      })
      if(res.message) this.$toasted.global.error({ message: res.message })
      else this.reissued = true
    },
    shuffle([...array]) {
      for (let i = array.length - 1; i >= 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    }
  }
}
</script>

<style lang="stylus" scoped>
.search-th
  width 300px
  height 20px
  background-color #3b7cab
  text-align center
  color #fff
  font-size 13px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

.f-15
  font-size: 15px;
</style>
